export const KNOWLEDGEBASE_TASK = 'data_collection_tlr_no';
export const NEUROPROFILER_TASK = 'neuroprofiler';
export const ANNUAL_REVIEW_PREPERATION_TASK = 'annualreviewpreparation';
export const BANK_ACCOUNT_REGISTRATION_TASK = 'bank_account_registration';
export const SELF_DECLARATION_TASK = 'selfdeclarationform';
